import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi from '@hapi/joi';
import { CashPluckingRateMappingAddEditSchemaObject } from '../CashPluckingRateMappingSchema';
import { validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const screenCode = 'CASHPLUCKINGRATEMAPPING';

export function CashPluckingRateMappingAddEdit(props) {
    const { data, edit } = props.location;
    const [groups, setGroups] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [cashWorkTypes, setCashWorkTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [mappingArray, setMappingArray] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isUpdate, setIsUpdate] = useState(false);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [isEnable, setIsEnable] = useState(true);
    const [cashPluckingRateMappingData, setCashPluckingRateMappingData] = useState({
        groupID: '0',
        estate: '0',
        divisionID: '0',
        jobTypeID: '0',
        cashWorkTypeID: '0',
        rate: 0.00,
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
        isActive: true,
    });
    const [jobTypes, setJobTypes] = useState([]);
    const schema = Joi.object(CashPluckingRateMappingAddEditSchemaObject).options({ allowUnknown: true });
    useEffect(() => {
        trackPromise(getPermissions());
        getAllGroups();
        GetAllJobType();
    }, []);

    useEffect(() => {
        if (cashPluckingRateMappingData.groupID !== '0') {
            const getEstatesForDropdown = async () => {
                const token = tokenService.getUserDetailsFromTokenV2();
                if (!token || !token.operationEntities || token.operationEntities.length === 0) return;

                const allEstates = await services.getEstatesByGroupID(cashPluckingRateMappingData.groupID);

                const estateMap = {};
                for (const item of Object.entries(token.operationEntities)) {
                    const entity = item[1];
                    estateMap[entity.OperationEntityID] = entity.OperationEntityName;
                }

                const filteredEstates = {};

                if (Array.isArray(allEstates)) {
                    for (let i = 0; i < allEstates.length; i++) {
                        const item = allEstates[i];

                        // Skip empty/undefined slots
                        if (!item) continue;

                        // If item is a string (estate name), check if it matches token permissions
                        if (typeof item === 'string') {
                            // Check if this estate name exists in our permissions
                            const matchingEntityId = Object.keys(estateMap).find(id =>
                                estateMap[id] === item
                            );

                            if (matchingEntityId) {
                                // Add to object with ID as key and name as value
                                filteredEstates[matchingEntityId] = item;
                            }
                        }
                        // If item is an object with OperationEntityID property
                        else if (item && typeof item === 'object' && item.OperationEntityID) {
                            if (estateMap[item.OperationEntityID]) {
                                filteredEstates[item.OperationEntityID] = item.OperationEntityName;
                            }
                        }
                    }
                }
                setEstates(filteredEstates);
            };
            getEstatesForDropdown();
        }
    }, [cashPluckingRateMappingData.groupID]);

    useEffect(() => {
        if (cashPluckingRateMappingData.estate !== '0') {
            getDivisionsForDropDown();
        }
    }, [cashPluckingRateMappingData.estate]);

    useEffect(() => {
        if (data !== undefined) {
            let cashWorkTypeMappingID = data.cashWorkTypeMappingID
            if (cashWorkTypeMappingID != 0) {
                trackPromise(getCashPluckingRateMappingDataById(cashWorkTypeMappingID))
            }
        }
    }, [data]);

    useEffect(() => {
        if (cashPluckingRateMappingData.jobTypeID !== '0') {
            GetAllCashWorkTypeByJobType();
        }
    }, [cashPluckingRateMappingData.jobTypeID]);

    async function getCashPluckingRateMappingDataById(cashWorkTypeMappingID) {
        let response = await services.GetCashPluckingRateMappingDataById(cashWorkTypeMappingID);
        let data = response.data[0];
        setIsUpdate(true);
        const formatDateString = (dateStr) => {
            const date = new Date(dateStr);
            return date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0');
        };

        setCashPluckingRateMappingData(prev => ({
            ...prev,
            groupID: data.groupID,
            estate: data.operationEntityID,
            divisionID: data.collectionPointID,
            jobTypeID: data.jobTypeID,
            rate: data.rate,
            cashWorkTypeID: data.cashWorkTypeID,
            isActive: data.isActive,
            fromDate: formatDateString(data.fromDate),
            toDate: formatDateString(data.toDate),
        }));
    }

    const handleChange = (e) => {
        validateInputs(e.target);
        if (e.target.name === "groupID") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value,
                estate: '0',
                divisionID: '0'
            });
            setMultipleEstates([]);
        }
        else if (e.target.name === "estate") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value,
                divisionID: '0'
            });
        } else if (e.target.name === "divisionID") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value
            });
        } else if (e.target.name === "jobTypeID") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value,
                cashWorkTypeID: '0'
            });
        }
        else {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value
            });
        }
    };



    function handleActiveChange(target) {
        validateInputs(target);

        setCashPluckingRateMappingData({
            ...cashPluckingRateMappingData,
            [target.name]: target.checked
        });
    }

    async function handleAdd(e) {
        e.preventDefault();
        const errorMessages = validate(schema, cashPluckingRateMappingData);
        setErrors(errorMessages || {});
        if (errorMessages && Object.keys(errorMessages).length > 0) {
            return;
        }

        if (isUpdate == true) {
            const updateModel = {
                cashWorkTypeMappingID: parseInt(data.cashWorkTypeMappingID),
                groupID: parseInt(cashPluckingRateMappingData.groupID),
                operationEntityID: parseInt(cashPluckingRateMappingData.estate),
                collectionPointID: parseInt(cashPluckingRateMappingData.divisionID),
                cashWorkTypeID: parseInt(cashPluckingRateMappingData.cashWorkTypeID),
                fromDate: cashPluckingRateMappingData.fromDate,
                toDate: cashPluckingRateMappingData.toDate,
                isActive: cashPluckingRateMappingData.isActive,
                rate: parseFloat(cashPluckingRateMappingData.rate).toFixed(2),
                createdBy: parseInt(tokenService.getUserIDFromToken()),
            };
            var response = await services.UpdateCashPluckingRateMappingData(updateModel);
            if (response.statusCode == "Success") {
                setMessageModel({
                    hidden: false,
                    type: "Success",
                    disciption: "Data updated successfully."
                });

                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Error", disciption: "" });
                    setIsUpdate(false)
                    props.history.push('/CashPluckingRateMapping');
                }, 4000);

            }
            else {
                setMessageModel({
                    hidden: false,
                    type: "Error",
                    disciption: response.message
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Error", disciption: "" });
                }, 4000);
            }
        } else {
            const newMappings = [];
            const baseModel = {
                cashWorkTypeMappingID: 0,
                groupID: parseInt(cashPluckingRateMappingData.groupID),
                operationEntityID: parseInt(cashPluckingRateMappingData.estate),
                collectionPointID: parseInt(cashPluckingRateMappingData.divisionID),
                cashWorkTypeID: parseInt(cashPluckingRateMappingData.cashWorkTypeID),
                rate: parseFloat(cashPluckingRateMappingData.rate).toFixed(2),
                fromDate: cashPluckingRateMappingData.fromDate,
                toDate: cashPluckingRateMappingData.toDate,
            };
            let isDuplicate = false;
            mappingArray.forEach(element => {
                if (element.groupID == baseModel.groupID && element.operationEntityID == baseModel.operationEntityID && element.cashWorkTypeID == baseModel.cashWorkTypeID &&
                    element.collectionPointID == baseModel.collectionPointID && element.fromDate == baseModel.fromDate && element.toDate == baseModel.toDate
                ) {
                    isDuplicate = true
                    setMessageModel({
                        hidden: false,
                        type: "Error",
                        disciption: "Can't add duplicate data"
                    });
                    setTimeout(() => {
                        setMessageModel({ hidden: true, type: "Error", disciption: "" });
                    }, 4000);
                    return;
                }
            });
            if (isDuplicate) {
                return;
            }
            newMappings.push({
                ...baseModel,
                groupName: parseInt(cashPluckingRateMappingData.groupID) > 0 ? groups[cashPluckingRateMappingData.groupID] : '',
                estateName: parseInt(cashPluckingRateMappingData.estate) > 0 ? estates[cashPluckingRateMappingData.estate] : '',
                cashWorkTypeName: parseInt(cashPluckingRateMappingData.cashWorkTypeID) > 0 ? cashWorkTypes[cashPluckingRateMappingData.cashWorkTypeID] : '',
                divisionName: parseInt(cashPluckingRateMappingData.divisionID) > 0 ? divisions[cashPluckingRateMappingData.divisionID] : '',
                isActive: cashPluckingRateMappingData.isActive,
                createdBy: parseInt(tokenService.getUserIDFromToken()),
                createdDate: new Date().toISOString()
            });

            if (newMappings.length > 0) {
                setMappingArray(prev => [...prev, ...newMappings]);
                setIsTableHidden(false);
            }
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                divisionID: '0',
                cashWorkTypeID: '0',
                jobTypeID: '0',
                rate: 0.00,
                isActive: true,
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0],
            });

        }
    }


    const DeleteDetails = (row) => {
        const updatedArray = mappingArray.filter(item => item !== row);
        setMappingArray(updatedArray);
    };
    async function saveCashPluckingRateMappingData() {
        if (mappingArray.length > 0) {
            var response = await services.SaveCashPluckingRateMappingData(mappingArray);

            if (response.statusCode === "Success") {
                setMessageModel({
                    hidden: false,
                    type: "Success",
                    disciption: response.message || "Cash plucking rate mapping data saved successfully."
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Success", disciption: "" });
                    props.history.push('/CashPluckingRateMapping');
                }, 4000);

                setMappingArray([]);
                setCashPluckingRateMappingData({
                    ...cashPluckingRateMappingData,
                    divisionID: '0',
                    cashWorkTypeID: '0',
                    jobTypeID: '0',
                    rate: 0.00,
                    fromDate: new Date().toISOString().split('T')[0],
                    toDate: new Date().toISOString().split('T')[0],
                    isActive: true,
                });
            }
            else if (response.statusCode === "Warning") {
                setMessageModel({
                    hidden: false,
                    type: "Warning",
                    disciption: response.message
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Warning", disciption: "" });
                    props.history.push('/CashPluckingRateMapping');
                }, 5000); 

                setMappingArray([]);
                setCashPluckingRateMappingData({
                    ...cashPluckingRateMappingData,
                    divisionID: '0',
                    cashWorkTypeID: '0',
                    jobTypeID: '0',
                    rate: 0.00,
                    fromDate: new Date().toISOString().split('T')[0],
                    toDate: new Date().toISOString().split('T')[0],
                    isActive: true,
                });
            }
            else {
                setMessageModel({
                    hidden: false,
                    type: "Error",
                    disciption: response.message || "Cash plucking rate mapping data not saved."
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Error", disciption: "" });
                }, 4000);
            }
        } else {
            setMessageModel({
                hidden: false,
                type: "Warning",
                disciption: "No data to save. Please add records first."
            });
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Warning", disciption: "" });
            }, 3000);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function getPermissions() {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'ADDEDITCASHPLUCKINGRATEMAPPING');
        if (!isAuthorized) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                groupID: token.groupID,
            })

        }
        else {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                groupID: token.groupID,
                estate: token.operationEntityID
            })
        }
        if (isUpdate === false) {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                groupID: token.groupID,
                estate: token.operationEntityID
            });
        }
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function GetAllJobType() {
        const data = await services.GetAllJobType();
        setJobTypes(data);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(cashPluckingRateMappingData.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(cashPluckingRateMappingData.estate);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    function clearButton() {
        setIsEnable(true);
        setCashPluckingRateMappingData({
            ...cashPluckingRateMappingData,
            divisionID: '0',
            cashWorkTypeID: '0',
            isActive: true,
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
        });
        setMappingArray([]);
        setErrors({});
    }

    function handleFromDateChange(target) {
        const newFromDate = target.value;
        const currentToDate = cashPluckingRateMappingData.toDate;

        setCashPluckingRateMappingData(prevState => ({
            ...prevState,
            fromDate: newFromDate,
            toDate: new Date(currentToDate) < new Date(newFromDate) ? newFromDate : currentToDate
        }));
    }

    function handleToDateChange(target) {
        const newToDate = target.value;

        setCashPluckingRateMappingData(prevState => ({
            ...prevState,
            toDate: newToDate
        }));
    }

    async function GetAllCashWorkTypeByJobType() {
        const data = await services.GetAllCashWorkTypeByJobType(cashPluckingRateMappingData.jobTypeID);
        setCashWorkTypes(data);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={isUpdate ? "Edit Cash Plucking Rate Mapping Data" : "Add Cash Plucking Rate Mapping Data"}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/CashPluckingRateMapping"
                        />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled || isUpdate}
                                            value={cashPluckingRateMappingData.groupID}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="estate">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estate"
                                            id="estate"
                                            name="estate"
                                            disabled={!isEnable || !permissionList.isOperationEntityFilterEnabled || isUpdate}
                                            value={cashPluckingRateMappingData.estate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={cashPluckingRateMappingData.divisionID}
                                            disabled={!isEnable || isUpdate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText error>{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="jobTypeID">JobType *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="jobTypeID"
                                            id="jobTypeID"
                                            name="jobTypeID"
                                            value={cashPluckingRateMappingData.jobTypeID}
                                            disabled={!isEnable || isUpdate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Job Type--</MenuItem>
                                            {generateDropDownMenu(jobTypes)}
                                        </Select>
                                        {errors["jobTypeID"] && <FormHelperText error>{errors["jobTypeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="cashWorkTypeID">Cash Work Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="cashWorkTypeID"
                                            id="cashWorkTypeID"
                                            name="cashWorkTypeID"
                                            value={cashPluckingRateMappingData.cashWorkTypeID}
                                            disabled={!isEnable || isUpdate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Cash Work Type--</MenuItem>
                                            {generateDropDownMenu(cashWorkTypes)}
                                        </Select>
                                        {errors["cashWorkTypeID"] && <FormHelperText error>{errors["cashWorkTypeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <TextField fullWidth label="Rate*"
                                            name="rate"
                                            id="rate"
                                            value={cashPluckingRateMappingData.rate}
                                            type="text"
                                            onChange={handleChange} />
                                        {errors["rate"] && <FormHelperText error>{errors["rate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={cashPluckingRateMappingData.fromDate}
                                            disabled={!isEnable || isUpdate}
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: new Date().toISOString().split('T')[0],
                                                max: new Date().toISOString().split('T')[0]
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText error>{errors["fromDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={cashPluckingRateMappingData.toDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: cashPluckingRateMappingData.fromDate,
                                                // max: new Date().toISOString().split('T')[0]
                                            }}
                                        />
                                        {errors["toDate"] && <FormHelperText error>{errors["toDate"]}</FormHelperText>}
                                    </div>
                                    <div className="form-group row w-100" style={{ marginTop: "10px", marginLeft: "10px" }}>
                                        <div className="col-md-3 pb-1">
                                            <InputLabel shrink htmlFor="isActive">Active</InputLabel>
                                            <input
                                                className="mr-2"
                                                id="isActive"
                                                switch="none"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleActiveChange(e.target)}
                                                checked={cashPluckingRateMappingData.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes" data-off-label="No"></label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value={isUpdate ? "Update" : "Add"}
                                            disabled={!isEnable}
                                            onClick={handleAdd}
                                        />
                                    </div>
                                </div>
                                {mappingArray.length > 0 && (
                                    <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Cash Work Type</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>From Date</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>To Date</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Rate </TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {mappingArray.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{row.divisionName}</TableCell>
                                                            <TableCell align="center">{row.cashWorkTypeName}</TableCell>
                                                            <TableCell align="center">{row.fromDate}</TableCell>
                                                            <TableCell align="center">{row.toDate}</TableCell>
                                                            <TableCell align="center">{row.rate}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton onClick={() => DeleteDetails(row)}>
                                                                    <DeleteIcon color="error" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                            <div className="card-footer">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Save"
                                                    onClick={saveCashPluckingRateMappingData}
                                                />
                                                <input
                                                    type="reset"
                                                    className="btn btn-warning pull-right"
                                                    value="Clear"
                                                    onClick={clearButton}
                                                />
                                            </div>
                                        </TableContainer>
                                    </Box>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}